// extracted by mini-css-extract-plugin
export default {"companies":"home_companies__xMfdR","boxes":"home_boxes__n0o1I","specificCSS":"home_specificCSS__WPSj4","videoContainer":"home_videoContainer__uOymg"};